<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-card class="size">
                <v-row class="px-0 pt-6 mx-0" align="center" justify="center">
                    <v-col cols="6">
                        <v-card class="ml-5 mr-1 middle_size_left_card">
                            <v-row class="ml-2 mr-1 py-0 my-2" justify="center" align="center">
                                <v-col cols="12" class="py-0">
                                    <label style="font-size: 16px; font-weight: bold;" class="blue_accent--text text-uppercase">{{$t('guide_detail.general_data')}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-4 py-0 mb-0 mt-1 " style="border-bottom: solid 1px rgba(0, 0, 0, 0.3);" justify="center" align="center">
                                <v-col cols="4" class="py-0 px-0">
                                    <label style="font-size: 16px; font-weight: bold;">{{$t('guide_detail.customer')}}</label>
                                </v-col>
                                <v-col cols="8" class="py-0 pr-2 pl-0 d-flex" style="justify-content: end;">
                                    <label style="font-size: 16px;">{{ guide.customer }}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-4 py-0 mb-0 mt-1 " style="border-bottom: solid 1px rgba(0, 0, 0, 0.3) ;" justify="center" align="center">
                                <v-col cols="4" class="py-0 px-0">
                                    <label style="font-size: 16px; font-weight: bold;">{{$t('guide_detail.shipping_service')}}</label>
                                </v-col>
                                <v-col cols="8" class="py-0 pr-2 pl-0 d-flex" style="justify-content: end;">
                                    <label style="font-size: 16px;">{{ guide.shipping_service }}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-4 py-0 mb-0 mt-1 " style="border-bottom: solid 1px rgba(0, 0, 0, 0.3) ;" justify="center" align="center">
                                <v-col cols="4" class="py-0 px-0">
                                    <label style="font-size: 16px; font-weight: bold;">{{$t('guide_detail.account')}}</label>
                                </v-col>
                                <v-col cols="8" class="py-0 pr-2 pl-0 d-flex" style="justify-content: end;">
                                    <label style="font-size: 16px;">{{ guide.account }}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-4 py-0 mb-0 mt-1 " style="border-bottom: solid 1px rgba(0, 0, 0, 0.3) ;" justify="center" align="center">
                                <v-col cols="4" class="py-0 px-0">
                                    <label style="font-size: 16px; font-weight: bold;">{{$t('guide_detail.guide')}}</label>
                                </v-col>
                                <v-col cols="8" class="py-0 pr-2 pl-0 d-flex" style="justify-content: end;">
                                    <label style="font-size: 16px;">{{ guide.guide }}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-4 py-0 mb-0 mt-1 " style="border-bottom: solid 1px rgba(0, 0, 0, 0.3) ;" justify="center" align="center">
                                <v-col cols="4" class="py-0 px-0">
                                    <label style="font-size: 16px; font-weight: bold;">{{$t('guide_detail.date')}}</label>
                                </v-col>
                                <v-col cols="8" class="py-0 pr-2 pl-0 d-flex" style="justify-content: end;">
                                    <label style="font-size: 16px;">{{ guide.date }}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-4 py-0 mb-0 mt-1 " style="border-bottom: solid 1px rgba(0, 0, 0, 0.3) ;" justify="center" align="center">
                                <v-col cols="4" class="py-0 px-0">
                                    <label style="font-size: 16px; font-weight: bold;">{{$t('guide_detail.weight')}}</label>
                                </v-col>
                                <v-col cols="8" class="py-0 pr-2 pl-0 d-flex" style="justify-content: end;">
                                    <label style="font-size: 16px;">{{ guide.weight }}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-4 py-0 mb-0 mt-1 " style="border-bottom: solid 1px rgba(0, 0, 0, 0.3) ;" justify="center" align="center">
                                <v-col cols="4" class="py-0 px-0">
                                    <label style="font-size: 16px; font-weight: bold;">{{$t('guide_detail.packing')}}</label>
                                </v-col>
                                <v-col cols="8" class="py-0 pr-2 pl-0 d-flex" style="justify-content: end;">
                                    <label style="font-size: 16px;">{{ guide.packing }}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-4 py-0 mb-0 mt-1 " style="border-bottom: solid 1px rgba(0, 0, 0, 0.3) ;" justify="center" align="center">
                                <v-col cols="4" class="py-0 px-0">
                                    <label style="font-size: 16px; font-weight: bold;">{{$t('guide_detail.volumetric_weight')}}</label>
                                </v-col>
                                <v-col cols="8" class="py-0 pr-2 pl-0 d-flex" style="justify-content: end;">
                                    <label style="font-size: 16px;">{{ guide.volumetric_weight }}</label>
                                </v-col>
                            </v-row>

                            <v-row class="px-0 ml-5 mr-4 py-0 mb-0 mt-1 " style="border-bottom: solid 1px rgba(0, 0, 0, 0.3) ;" justify="center" align="center">
                                <v-col cols="4" class="py-0 px-0">
                                    <label style="font-size: 16px; font-weight: bold;">{{$t('guide_detail.insurance_amount')}}</label>
                                </v-col>
                                <v-col cols="8" class="py-0 pr-2 pl-0 d-flex" style="justify-content: end;">
                                    <label style="font-size: 16px;">{{ guide.insurance_amount }}</label>
                                </v-col>
                            </v-row>

                            <v-row class="px-0 ml-5 mr-4 py-0 mb-0 mt-1 " style="border-bottom: solid 1px rgba(0, 0, 0, 0.3) ;" justify="center" align="center">
                                <v-col cols="4" class="py-0 px-0">
                                    <label style="font-size: 16px; font-weight: bold;">{{$t('guide_detail.origin')}}</label>
                                </v-col>
                                <v-col cols="8" class="py-0 pr-2 pl-0 d-flex" style="justify-content: end;">
                                    <label style="font-size: 16px;">{{ guide.origin }}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-4 py-0 mb-0 mt-1 " style="border-bottom: solid 1px rgba(0, 0, 0, 0.3) ;" justify="center" align="center">
                                <v-col cols="4" class="py-0 px-0">
                                    <label style="font-size: 16px; font-weight: bold;">{{$t('guide_detail.destination')}}</label>
                                </v-col>
                                <v-col cols="8" class="py-0 pr-2 pl-0 d-flex" style="justify-content: end;">
                                    <label style="font-size: 16px;">{{ guide.destination }}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-4 py-0 mb-0 mt-1 " style="border-bottom: solid 1px rgba(0, 0, 0, 0.3) ;" justify="center" align="center">
                                <v-col cols="4" class="py-0 px-0">
                                    <label style="font-size: 16px; font-weight: bold;">{{$t('guide_detail.zone')}}</label>
                                </v-col>
                                <v-col cols="8" class="py-0 pr-2 pl-0 d-flex" style="justify-content: end;">
                                    <label style="font-size: 16px;">{{ guide.zone }}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 ml-5 mr-4 py-0 mb-0 mt-1 " style="border-bottom: solid 1px rgba(0, 0, 0, 0.3) ;" justify="center" align="center">
                                <v-col cols="4" class="py-0 px-0">
                                    <label style="font-size: 16px; font-weight: bold;">{{$t('guide_detail.extended_zone')}}</label>
                                </v-col>
                                <v-col cols="8" class="py-0 pr-2 pl-0 d-flex" style="justify-content: end;">
                                    <label style="font-size: 16px;">{{ $t(guide.extended_zone) }}</label>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>

                    <v-col cols="6">
                        <v-card class="mr-5 ml-1 middle_size_left_card">
                            <v-row class="px-0 mr-0 ml-5 py-0 my-2" justify="center" align="center">
                                <v-col cols="12" class="py-0">
                                    <label style="font-size: 16px; font-weight: bold;" class="blue_accent--text text-uppercase">{{$t('guide_detail.delivery_details')}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 mr-5 ml-5 py-0 my-1" justify="center" align="center">
                                <v-col cols="6" class="py-0" justify="start" align="start">
                                    <label>{{ $t('guide_detail.status')}}</label>
                                </v-col>
                                <v-col cols="6" class="py-0" justify="end" align="center">
                                    <label>{{ $t('guide_detail.date')}}</label>
                                </v-col>
                            </v-row>
                            <v-row class="px-0 mr-7 ml-7 py-0 my-1" v-for="status of guide.status" :key="status.id" style="border-bottom: 1px solid var(--v-accent-base); border-radius: 0px;" justify="center" align="center">
                                <v-col cols="6" class="py-0" justify="start" align="start">
                                    <label style="font-size: 14px;"> {{status.status}} </label>
                                </v-col>
                                <v-col cols="6" class="py-0" justify="end" align="center">
                                    <label style="font-size: 14px;" v-if="status.date == null"> {{ status.reg_date.includes("T")? status.reg_date.split('T')[0]: status.reg_date.split(' ')[0] }} {{ status.reg_date.includes("T")? status.reg_date.split('T')[1].substring(0, 5) : status.reg_date.split(' ')[1].substring(0, 5) }} </label>
                                    <label style="font-size: 14px;" v-else> {{ status.date }} </label>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>

                <v-row class="px-0 pt-0 mx-5 mt-2" align="center" justify="center">
                    <v-col cols="12" class="mx-0">
                        <v-card class="pt-1 pb-4">
                            <v-row class="ml-5 mr-1 py-0 my-2" justify="center" align="center">
                                <v-col cols="12" class="py-0">
                                    <label style="font-size: 16px; font-weight: bold;" class="blue_accent--text text-uppercase">{{$t('guide_detail.collection_details')}}</label>
                                </v-col>
                            </v-row>
                            
                            <!-- HEADERS -->
                            <v-row class="px-0 mr-5 ml-5 py-0 my-1" justify="center" align="center">
                                <v-col cols="4" class="py-0" justify="start" align="start">
                                    <label style="font-size: 14px;">{{$t('guide_detail.concept')}}</label>
                                </v-col>
                                
                                <v-spacer></v-spacer>

                                <v-col cols="2" class="py-0" justify="center" align="center">
                                    <label style="font-size: 14px;">{{$t('guide_detail.collected_amount')}}</label>
                                </v-col>
                                <v-col cols="2" class="py-0" justify="center" align="center">
                                    <label style="font-size: 14px;">{{$t('guide_detail.collected_date')}}</label>
                                </v-col>
                            </v-row>

                            <v-row class="px-0 mr-5 ml-5 py-0 my-1" v-bind:class="(guide.guide_charge.shipping_cost_charged_date == null ? 'rounded-orange': 'rounded-green')"
                                 justify="center" align="center">
                                <v-col cols="4" class="py-0" justify="start" align="start">
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.shipping_cost_charged_date == null ? 'filled_accent--text': 'accent--text')">{{$t('guide_detail.shipping_cost')}}</label>
                                </v-col>

                                <v-spacer></v-spacer>

                                <v-col cols="2" class="py-0" justify="center" align="center">
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.shipping_cost_charged_date == null ? 'filled_accent--text': 'accent--text')">{{ '$' + numberFormat.format(guide.guide_charge.shipping_cost_charged) }}</label>
                                </v-col>
                                <v-col cols="2" class="py-0" justify="center" align="center">
                                    <label style="font-size: 14px;" :class="(guide.guide_charge.shipping_cost_charged_date == null ? 'filled_accent--text': 'accent--text')">{{ guide.guide_charge.shipping_cost_charged_date }}</label>
                                </v-col>
                            </v-row>                            

                            <v-row class="px-0 mr-5 ml-5 py-0 my-1" v-bind:class="(
                                guide.guide_charge.extended_zone_cost_charged == 0 ? 'rounded-grey' : 
                                (guide.guide_charge.extended_zone_cost_charged != 0 && guide.guide_charge.extended_zone_cost_charged_date == null ? 'rounded-orange': 'rounded-green'))"
                                justify="center" align="center">
                                <v-col cols="4" class="py-0" justify="start" align="start">
                                    <label style="font-size: 14px;" :class="(guide.guide_charge.extended_zone_cost_charged_date == null ? 'filled_accent--text': 'accent--text')">{{$t('guide_detail.extended_zone')}}</label>
                                </v-col>

                                <v-spacer></v-spacer>

                                <v-col cols="2" class="py-0" justify="center" align="center">
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.extended_zone_cost_charged_date == null ? 'filled_accent--text': 'accent--text')">{{ '$' + numberFormat.format(guide.guide_charge.extended_zone_cost_charged) }}</label>
                                </v-col>
                                <v-col cols="2" class="py-0" justify="center" align="center">
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.extended_zone_cost_charged_date == null ? 'filled_accent--text': 'accent--text')">{{ guide.guide_charge.extended_zone_cost_charged_date }}</label>
                                </v-col>
                            </v-row>

                            <v-row class="px-0 mr-5 ml-5 py-0 my-1" v-bind:class="(!guide.has_return ? 'rounded-grey' : (guide.guide_charge.return_cost_charged_date == null && guide.has_return ? 'rounded-green' : 'rounded-orange'))"
                                justify="center" align="center">
                                <v-col cols="4" class="py-0" justify="start" align="start">
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.return_cost_charged_date == null ? 'accent--text': 'filled_accent--text')">{{$t('guide_detail.return')}}</label>
                                </v-col>
                                
                                <v-spacer></v-spacer>

                                <v-col cols="2" class="py-0" justify="center" align="center">
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.return_cost_charged_date == null ? 'accent--text': 'filled_accent--text')" v-if="guide.has_return">{{ '$' + numberFormat.format(guide.guide_charge.return_cost_charged) }}</label>
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.return_cost_charged_date == null ? 'accent--text': 'filled_accent--text')" v-else>{{ '$' + numberFormat.format(0) }}</label>
                                </v-col>
                                <v-col cols="2" class="py-0" justify="center" align="center">
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.return_cost_charged_date == null ? 'accent--text': 'filled_accent--text')" v-if="guide.has_return">{{ guide.guide_charge.return_cost_charged_date }}</label>
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.return_cost_charged_date == null ? 'accent--text': 'filled_accent--text')" v-else>---</label>
                                </v-col>
                            </v-row>

                            <v-row class="px-0 mr-5 ml-5 py-0 my-1" v-bind:class="(guide.guide_charge.extra_large_paid == 0 ? 'rounded-grey' : 'rounded-green')"
                                justify="center" align="center">
                                <v-col cols="4" class="py-0" justify="start" align="start">
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.extra_large_paid == 0 ? 'filled_accent--text': 'accent--text')">{{$t('guide_detail.extralarge_packing')}}</label>
                                </v-col>

                                <v-spacer></v-spacer>

                                <v-col cols="2" class="py-0" justify="center" align="center">
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.extra_large_paid == 0 ? 'filled_accent--text': 'accent--text')" v-if="guide.guide_charge.extra_large_paid != 0">{{ '$' + numberFormat.format(guide.guide_charge.extra_large_cost_charged) }}</label>
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.extra_large_paid == 0 ? 'filled_accent--text': 'accent--text')" v-else>{{ '$' + numberFormat.format(0) }}</label>
                                </v-col>
                                <v-col cols="2" class="py-0" justify="center" align="center">
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.extra_large_paid == 0 ? 'filled_accent--text': 'accent--text')" v-if="guide.guide_charge.extra_large_paid != 0">{{ guide.guide_charge.extra_large_cost_charged_date }}</label>
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.extra_large_paid == 0 ? 'filled_accent--text': 'accent--text')" v-else>---</label>
                                </v-col>
                            </v-row>

                             <v-row class="px-0 mr-5 ml-5 py-0 my-1" v-bind:class="(guide.guide_charge.address_correction_paid == 0 ? 'rounded-grey' : 'rounded-green')"
                                justify="center" align="center">
                                <v-col cols="4" class="py-0" justify="start" align="start">
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.address_correction_paid == 0 ? 'filled_accent--text': 'accent--text')">{{$t('guide_detail.address_correction')}}</label>
                                </v-col>

                                <v-spacer></v-spacer>

                                <v-col cols="2" class="py-0" justify="center" align="center">
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.address_correction_paid == 0 ? 'filled_accent--text': 'accent--text')" v-if="guide.guide_charge.address_correction_paid != 0">{{ '$' + numberFormat.format(guide.guide_charge.address_correction_cost_charged) }}</label>
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.address_correction_paid == 0 ? 'filled_accent--text': 'accent--text')" v-else>{{ '$' + numberFormat.format(0) }}</label>
                                </v-col>
                                <v-col cols="2" class="py-0" justify="center" align="center">
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.address_correction_paid == 0 ? 'filled_accent--text': 'accent--text')" v-if="guide.guide_charge.address_correction_paid != 0">{{ guide.guide_charge.address_correction_cost_charged_date }}</label>
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.address_correction_paid == 0 ? 'filled_accent--text': 'accent--text')" v-else>---</label>
                                </v-col>
                            </v-row>

                            <v-row class="px-0 mr-5 ml-5 py-0 my-1" v-bind:class="(guide.guide_charge.saturday_pickup_paid == 0 ? 'rounded-grey' : 'rounded-green')"
                                justify="center" align="center">
                                <v-col cols="4" class="py-0" justify="start" align="start">
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.saturday_pickup_paid == 0 ? 'filled_accent--text': 'accent--text')">{{$t('guide_detail.saturday_collection')}}</label>
                                </v-col>
                                
                                <v-spacer></v-spacer>

                                <v-col cols="2" class="py-0" justify="center" align="center">
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.saturday_pickup_paid == 0 ? 'filled_accent--text': 'accent--text')" v-if="guide.guide_charge.saturday_pickup_paid != 0">{{ '$' + numberFormat.format(guide.guide_charge.saturday_pickup_cost_charged) }}</label>
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.saturday_pickup_paid == 0 ? 'filled_accent--text': 'accent--text')" v-else>{{ '$' + numberFormat.format(0) }}</label>
                                </v-col>
                                <v-col cols="2" class="py-0" justify="center" align="center">
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.saturday_pickup_paid == 0 ? 'filled_accent--text': 'accent--text')" v-if="guide.guide_charge.saturday_pickup_paid != 0">{{ guide.guide_charge.saturday_pickup_cost_charged_date }}</label>
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.saturday_pickup_paid == 0 ? 'filled_accent--text': 'accent--text')" v-else>---</label>
                                </v-col>
                            </v-row>

                            <v-row class="px-0 mr-5 ml-5 py-0 my-1" v-bind:class="(guide.guide_charge.overweight_paid == 0 ? 'rounded-grey' : 'rounded-green')"
                                justify="center" align="center">
                                <v-col cols="4" class="py-0" justify="start" align="start">
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.overweight_paid == 0 ? 'filled_accent--text': 'accent--text')">{{$t('guide_detail.weight_excess_cost')}}</label>
                                </v-col>

                                <v-spacer></v-spacer>

                                <v-col cols="2" class="py-0" justify="center" align="center">
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.overweight_paid == 0 ? 'filled_accent--text': 'accent--text')" v-if="guide.guide_charge.overweight_paid != 0">{{ '$' + numberFormat.format(guide.guide_charge.overweight_cost_charged) }}</label>
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.overweight_paid == 0 ? 'filled_accent--text': 'accent--text')" v-else>{{ '$' + numberFormat.format(0) }}</label>
                                </v-col>
                                <v-col cols="2" class="py-0" justify="center" align="center">
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.overweight_paid == 0 ? 'filled_accent--text': 'accent--text')" v-if="guide.guide_charge.overweight_paid != 0">{{ guide.guide_charge.overweight_cost_charged_date }}</label>
                                    <label style="font-size: 14px;" :class=" (guide.guide_charge.overweight_paid == 0 ? 'filled_accent--text': 'accent--text')" v-else>---</label>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>   
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
import { showGuideUseCase } from "../application/use_cases/show_guide_use_case";
import { HttpGuideRepository } from "../infrastructure/repositories/guide_repository";

export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]}, 
        client: function(){
            return this.$store.state.clientId
        }
    },
    data(){
        return {
            id: this.$route.params.id,
            numberFormat: new Intl.NumberFormat('en-us', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            guide: {
                id: "",
                customer: "",
                shipping_service: "",
                account: "",
                guide: "",
                date: "",
                weight: "",
                packing: "",
                volumetric_weight: "",
                insurance_amount: "",
                origin: "",
                destination: "",
                zone: "",
                extended_zone: "",
                status: [{
                    id: 1,
                    status: "DELIVERED",
                    date: "2025-05-21"
                }],
                guide_charge: {}
            }
        }
    },
    mounted(){
        this.$store.state.module = "headers.guide_detail";
        this.loadData();
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async loadData(){
            try {
                this.guide = await showGuideUseCase(this.id, HttpGuideRepository);
                console.log(this.guide)
            } catch (e) {
                console.log(e)
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        }
    },
    watch: {}
}
</script>
<style>
</style>